import { Validators } from '@angular/forms';

export const PAGE_SIZES = [50, 100, 200, 500, 1000, 2500, 5000, 10000];
export const CURRENCIES = [
  {
    id: 'EUR',
    name: 'EUR',
    code: 'EUR',
  },
  {
    id: 'GBP',
    name: 'GBP',
    code: 'GBP',
  },
  {
    id: 'USD',
    name: 'USD',
    code: 'USD',
  },
];

export const ETR_TYPE = [
  // { name: 'a-ETR', id: 'a-ETR', fullName: 'a-ETR - Finance an Asset' },
  { name: 'b-ETR', id: 'b-ETR', fullName: 'b-ETR - Pay a Single Supplier' },
  // { name: 'b-ETR', id: 'ms', fullName: 'b-ETR - Open Multiple Supplier Contract' },
  { name: 'c-ETR', id: 'c-ETR', fullName: 'c-ETR - Credit Card' },
  { name: 'd-ETR', id: 'd-ETR', fullName: 'd-ETR - Debtor Finance' },
  // { name: 'f-ETR', id: 'f-ETR', fullName: 'f-ETR - Finance Future Income' },
];

export const ETR_TYPES = [
  { name: 'a-ETR', id: 'a-ETR' },
  { name: 'b-ETR', id: 'b-ETR' },
  { name: 'c-ETR', id: 'c-ETR' },
  { name: 'd-ETR', id: 'd-ETR' },
  { name: 'f-ETR', id: 'f-ETR' },
  { name: 'Credit Note', id: 'Credit Note' },
  { name: 'Deduction', id: 'Deduction' },
  { name: 'Deposit', id: 'Deposit' },
  { name: 'OCPA', id: 'OCPA' },
  { name: 'ICP', id: 'ICP' },
  { name: 'RSA', id: 'RSA' },
];

export const TYPES: Array<{ id: string; name: string }> = [
  {
    id: 'Debtor',
    name: 'Debtor',
  },
  {
    id: 'Creditor',
    name: 'Creditor',
  },
];

export const Transaction_Types = [
  {
    label: 'Debtors',
    options: [
      'Bank Transmission Receipt',
      'Notice of Debtor Remittance',
      'Credit Note',
      // 'Account Reconciliation',
    ],
  },
];

export enum StatusEnum {
  AWAITING = 'Awaiting',
  ANALYSED = 'Analysed',
  APPROVED = 'Approved',
  AUTHORISED = 'Authorised',
}

export const CCY_SORT_ORDER = [
  'EUR',
  'GBP',
  'USD',
  'CAD',
  'CHF',
  'HKD',
  'NZD',
  'NGN',
];

export const VALIDATOR_ONLY_SPACES = Validators.pattern('.*\\S.*');
